var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[(_vm.$route.name !== 'Legal' && _vm.$route.name !== 'MStarLegal')?_c('span',[_c('router-link',{attrs:{"to":_vm.getLegalLink}},[_vm._v(_vm._s(_vm.$t('LegalDisclamerLink')))]),_vm._v(" | \n    ")],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.$t('Copyright', { year: _vm.currentYear })))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b44fce06","hasScoped":true,"transformToRequire":{"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = HysS
// module chunks = 1